<template>
    <div class="detailBread">
  <router-link to="/home" class="linked">首页</router-link>
  <span>/</span>
  <router-link to="/news" class="linked">资讯中心</router-link>
  <span>/</span>
  <a>正文</a>
</div>
</template>

<style scoped>
.detailBread {
    display: block;
    height: 80px;
    width: 1200px;
    margin: 0 auto;
    line-height: 80px;
}

.detailBread a {
    display: inline-block;
    color: #151515;
    font-size: 14px;
}

.detailBread a.linked {
    color: #8C8C8C;
    font-size: 14px;
}

.detailBread a.linked:hover {
    color: var(--link-hover-color)
}

.detailBread span {
    display: inline-block;
    color: #8C8C8C;
    font-size: 14px;
    margin-left: 5px;
    padding-right: 5px;
}
</style>